import React from 'react';
import { ExclamationTriangleIcon, DocumentIcon, BuildingOfficeIcon } from '@heroicons/react/24/outline';

const ProblemStatement = () => {
  const problems = [
    {
      icon: ExclamationTriangleIcon,
      title: "Wasted Screen Assets",
      description: "Over 2.3 million digital displays in businesses show static content or remain completely unused, representing $890M in lost revenue potential annually."
    },
    {
      icon: DocumentIcon,
      title: "Ineffective Ad Spend",
      description: "Traditional advertising wastes 67% of budget on wrong audiences. Digital billboards cost $14,000+ monthly with no targeting or performance tracking."
    },
    {
      icon: BuildingOfficeIcon,
      title: "No Real-Time Data",
      description: "Most advertising platforms provide delayed, inaccurate metrics. Businesses can't optimize campaigns or measure true ROI in real-time."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-6">
            The Problem Is Real
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Millions of screens sit idle while businesses struggle with ineffective advertising
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            {problems.map((problem, index) => (
              <div key={index} className="flex items-start space-x-4">
                <div className="bg-error/10 p-3 rounded-full">
                  <problem.icon className="w-6 h-6 text-error" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-text-primary mb-2">{problem.title}</h3>
                  <p className="text-text-secondary">{problem.description}</p>
                </div>
              </div>
            ))}
          </div>
          
          <div className="relative">
            <img 
              src="https://images.pixabay.com/photo-2016/11/29/06/15/plans-1867745_1280.jpg" 
              alt="Business analytics showing declining performance" 
              className="w-full h-96 object-cover rounded-2xl shadow-card"
              onError={(e) => {
                e.target.src = 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2940&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D';
              }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-2xl"></div>
            <div className="absolute bottom-6 left-6 text-white">
              <div className="text-3xl font-bold">₹900M</div>
              <div className="text-sm opacity-90">Lost Revenue Annually</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemStatement;